module.exports = __webpack_public_path__ + "img/authx.a001118c.svg";